import React from 'react';

const StudentsTable = ({ students, isSuperAdmin, isDirector, openEdit, handleDelete }) => (
  <div className="admins-table-scroll">
  <table className="admins-table students-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>DOB</th>
        <th>Gender</th>
        <th>Class</th>
        <th>Section</th>
        <th>Roll No</th>
        <th>Guardian</th>
        <th>Phone</th>
        <th>Admission Date</th>
        <th>Added By</th>
        <th>Updated By</th>
        <th>Created Date</th>
        <th>Updated Date</th>
        <th className="actions-header">Actions</th>
      </tr>
    </thead>
    <tbody>
      {students.map(s => (
        <tr key={s._id}>
          <td>{s.name}</td>
          <td>{s.dob && new Date(s.dob).toLocaleDateString()}</td>
          <td>{s.gender}</td>
          <td>{s.class}</td>
          <td>{s.section}</td>
          <td>{s.rollNumber}</td>
          <td>{s.guardianName}</td>
          <td>{s.guardianPhone}</td>
          <td>{s.admissionDate && new Date(s.admissionDate).toLocaleDateString()}</td>
          <td>{s.createdBy ? s.createdBy.name : 'N/A'}</td>
          <td>{s.updatedBy ? s.updatedBy.name : 'N/A'}</td>
          <td>{s.createdAt ? new Date(s.createdAt).toLocaleString() : 'N/A'}</td>
          <td>{s.updatedAt ? new Date(s.updatedAt).toLocaleString() : 'N/A'}</td>
          <td>
            <div className="admin-actions">
              {(isSuperAdmin || isDirector) ? (
                <>
                  <button className="edit-btn" onClick={() => openEdit(s)}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDelete(s._id)}>Delete</button>
                </>
              ) : (
                <>
                  <button className="edit-btn" disabled>Edit</button>
                  <button className="delete-btn" disabled>Delete</button>
                </>
              )}
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  </div>
);

export default StudentsTable; 